import {
  CIVILMATERIALACOUNT_LOADING,
  GET_CIVILMATERIALACOUNT,
  GET_CIVILMATERIALACOUNT_SUCCESS,
  GET_CIVILMATERIALACOUNT_FAIL,
  ADD_CIVILMATERIALACOUNT_SUCCESS,
  ADD_CIVILMATERIALACOUNT_FAIL,
  DELETE_CIVILMATERIALACOUNT_SUCCESS,
  DELETE_CIVILMATERIALACOUNT_FAIL,
  UPDATE_CIVILMATERIALACOUNT_SUCCESS,
  UPDATE_CIVILMATERIALACOUNT_FAIL,
  CIVILMATERIALACOUNT_RESET
} from "./actionType";

const INIT_STATE = {
  civilAccounts: [],
  error: {},
};

const CivilAccount = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_CIVILMATERIALACOUNT_SUCCESS:
      switch (action.payload.actionType) {
        case GET_CIVILMATERIALACOUNT:
          return {
            ...state,
            civilAccounts: action.payload.data,
            isCivilAccountCreated: false,
            isCivilAccountSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_CIVILMATERIALACOUNT_FAIL:
      switch (action.payload.actionType) {
        case GET_CIVILMATERIALACOUNT_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isCivilAccountCreated: false,
            isCivilAccountSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_CIVILMATERIALACOUNT: {
      return {
        ...state,
        isCivilAccountCreated: false,
        loading: true,
      };
    }

    case CIVILMATERIALACOUNT_LOADING: {
      return {
        ...state,
        isCivilAccountCreated: false,
        loading: true,
      };
    }

    case ADD_CIVILMATERIALACOUNT_SUCCESS:
      return {
        ...state,
        isCivilAccountCreated: true,
        loading: false,
        civilAccounts: [action.payload.data, ...state.civilAccounts],
      };

    case ADD_CIVILMATERIALACOUNT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_CIVILMATERIALACOUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        civilAccounts: state.civilAccounts.filter(
          civilCivilAccount => civilCivilAccount.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_CIVILMATERIALACOUNT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_CIVILMATERIALACOUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        civilAccounts: state.civilAccounts.map(civilCivilAccount =>
          civilCivilAccount.id.toString() === action.payload.data.id.toString() ? { ...civilCivilAccount, ...action.payload.data } : civilCivilAccount
        ),
      };

    case UPDATE_CIVILMATERIALACOUNT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CIVILMATERIALACOUNT_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default CivilAccount;